import { render, staticRenderFns } from "./CardVisualBox.vue?vue&type=template&id=371515dd&scoped=true&"
import script from "./CardVisualBox.vue?vue&type=script&lang=js&"
export * from "./CardVisualBox.vue?vue&type=script&lang=js&"
import style0 from "./CardVisualBox.vue?vue&type=style&index=0&id=371515dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371515dd",
  null
  
)

export default component.exports